import { Box, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

import { Divider } from '@/components/Layout/Divider';

type ReviewCardProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  currentIndex: number;
  totalSections: number;
} & PropsWithChildren;

export function ReviewCard({
  title,
  subtitle,
  currentIndex,
  totalSections,
  children,
}: Readonly<ReviewCardProps>) {
  return (
    <Box
      sx={{
        borderRadius: 1.5,
        boxShadow: theme => theme.shadows[1],
        backgroundColor: 'background.paper',
        p: 1.5,
      }}
    >
      <Box display="flex" justifyContent="space-between" mb={1}>
        <Box>
          <Typography variant="headlineH5">{title}</Typography>
          {subtitle && (
            <Typography variant="captionC1Regular" color="neutral.600" mt={0.5}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <Typography variant="bodyB2Regular" color="neutral.600">
          {currentIndex}/{totalSections}
        </Typography>
      </Box>
      <Divider width={'100%'} />
      {children}
    </Box>
  );
}
